import React, { useState } from 'react';
import { Box, Dialog, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';

import OverdueInvoices from '../Payments/OverdueInvoices';
import PaymentRegistrationModal from '../Payments/PaymentRegistrationModal';
import PendingInvoices from '../Payments/PendingInvoices';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div aria-labelledby={`payment-tab-${index}`} hidden={value !== index} id={`payment-tabpanel-${index}`} role="tabpanel" {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const InvoicesWithPaymentEdit = ({ customerId, userId }) => {
  const { t } = useTranslation('admin', { keyPrefix: 'property.users.invoices' });
  const [activeTab, setActiveTab] = useState(0);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [paymentRefresh, setPaymentRefresh] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleRegisterPayment = (invoice, type) => {
    setSelectedInvoice({ ...invoice, paymentType: type });
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedInvoice(null);
  };

  const handlePaymentSuccess = () => {
    setPaymentRefresh(prev => prev + 1);
    setModalOpen(false);
    setSelectedInvoice(null);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs aria-label="payment tabs" onChange={handleTabChange} value={activeTab}>
          <Tab aria-controls="payment-tabpanel-0" id="payment-tab-0" label={t('tabs.pending')} />
          <Tab aria-controls="payment-tabpanel-1" id="payment-tab-1" label={t('tabs.overdue')} />
        </Tabs>
      </Box>
      <TabPanel index={0} value={activeTab}>
        <PendingInvoices
          customerId={customerId}
          onRegisterPayment={invoice => handleRegisterPayment(invoice, 'regular')}
          paymentRefresh={paymentRefresh}
          userId={userId}
        />
      </TabPanel>
      <TabPanel index={1} value={activeTab}>
        <OverdueInvoices
          customerId={customerId}
          onRegisterPayment={invoice => handleRegisterPayment(invoice, 'overdue')}
          paymentRefresh={paymentRefresh}
          userId={userId}
        />
      </TabPanel>
      <Dialog fullWidth maxWidth="md" onClose={handleModalClose} open={modalOpen}>
        {selectedInvoice && (
          <PaymentRegistrationModal
            invoice={selectedInvoice}
            onClose={handleModalClose}
            onSuccess={handlePaymentSuccess}
            type={selectedInvoice.paymentType}
          />
        )}
      </Dialog>
    </Box>
  );
};

export default InvoicesWithPaymentEdit;
